


















import { Component, Vue, Prop } from 'vue-property-decorator';
import uuidv4 from 'uuidv4';

@Component({})
export default class Radio extends Vue {
    @Prop() value?: string;
    @Prop() options?: { [key: string]: string };

    uuid: string = uuidv4();
}
